import React, { Component } from "react";
import { API_URI } from "../consts";

const FilesPermsList = (props) => {
    return (
        <ul className="list-group" style={{paddingTop:"20px"}}>
            {props.files.length === 0 ?
                <li className="list-group-item list-group-item-info" key={1}>
                    No se encontraron resultados
                </li>
                :
                props.files.map(file => (
                    <li className="list-group-item list-group-item-info" key={file.id}>
                        <a className="btn btn-success btn-xs pull-right"
                           href={`${API_URI}download-perm?fileId=${file.id}`}>
                            <span className="glyphicon glyphicon-download"></span>
                        </a>
                        {file.name}
                    </li>
                ))
            }
        </ul>
    )
};

export default FilesPermsList;


// WEBPACK FOOTER //
// ./frontEnd/covid/permiso-unico-colectivo/components/FilesPermsList.jsx